// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2PointsOrderModal-Mc2PointsOrderModal-module__box--wbxmm {
  height: 100%;
  overflow: auto;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2PointsOrderModal-Mc2PointsOrderModal-module__list--nrPob {
  display: flex;
  flex-direction: column;
  list-style: none;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2PointsOrderModal-Mc2PointsOrderModal-module__row--ToF7q {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 0;
  cursor: move;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2PointsOrderModal-Mc2PointsOrderModal-module__name--le7UJ {
  width: 80px;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2PointsOrderModal-Mc2PointsOrderModal-module__descr--A_ll3 {
  flex: 1;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2PointsOrderModal-Mc2PointsOrderModal-module__icon--Txgd1 {
  width: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsMeasurementChart2/Mc2Summary/Mc2Entity/Mc2PointsOrderModal/Mc2PointsOrderModal.module.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,cAAA;AACF;AAEA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AAAF;AAGA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;AADF;AAGA;EACE,WAAA;AADF;AAGA;EACE,OAAA;AADF;AAGA;EACE,WAAA;AADF","sourcesContent":[".box {\n  height: 100%;\n  overflow: auto;\n}\n\n.list {\n  display: flex;\n  flex-direction: column;\n  list-style: none;\n}\n\n.row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 5px 0;\n  cursor: move;\n}\n.name {\n  width: 80px;\n}\n.descr {\n  flex: 1;\n}\n.icon {\n  width: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2PointsOrderModal-Mc2PointsOrderModal-module__box--wbxmm`,
	"list": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2PointsOrderModal-Mc2PointsOrderModal-module__list--nrPob`,
	"row": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2PointsOrderModal-Mc2PointsOrderModal-module__row--ToF7q`,
	"name": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2PointsOrderModal-Mc2PointsOrderModal-module__name--le7UJ`,
	"descr": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2PointsOrderModal-Mc2PointsOrderModal-module__descr--A_ll3`,
	"icon": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2PointsOrderModal-Mc2PointsOrderModal-module__icon--Txgd1`
};
export default ___CSS_LOADER_EXPORT___;
